import React, {useCallback, useLayoutEffect, useState} from 'react';
import {
  View,
  Image,
  Platform,
  ScrollView,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from 'react-native';

import HTML from 'react-native-render-html';

import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {StyleSheet} from 'react-native';
import {colorPalette} from '../../../core/config/color.config';
import {LogoLight} from './../../images/Image';

import {RNEText} from '../../components';
import HeaderBackLeft from '../../views/navigation/HeaderBackLeft';

import {HTMLPrivacyPolicy} from './../../data/policy/privacy-policy';
import {ContentScrollView} from '../../views';
import {width, height, totalSize} from 'react-native-dimension';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';

const PrivacyPolicyAuthScreen = () => {
  const navigation = useNavigation();

  const goToLogin = () => {
    navigation.navigate(NavigationKey.LOGIN_SCREEN);
  };

  const onTermsClick = () => {
    navigation.navigate(NavigationKey.TANDC_SCREEN);
  };

  const {setCanRefresh} = usePullDownRefreshContext();

  useLayoutEffect(() => {
    navigation.setOptions(
      Platform.OS === 'web'
        ? {
            headerShown: false,
          }
        : {
            headerShown: true,
            title: '',
            headerStyle: {
              elevation: 0,
              shadowOpacity: 0,
            },
            headerTintColor: colorPalette.blackLight,
            headerTitleStyle: {
              fontFamily: 'Quicksand-Regular',
              fontSize: 14,
              paddingLeft: 28,
            },
            headerLeft: () => <HeaderBackLeft removeLabel />,
          },
    );
  }, [navigation]);

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

  return (
    <>
      {Platform.OS === 'web' ? (
        <View style={webStyles.root}>
          <View style={webStyles.logoContainer}>
            <TouchableWithoutFeedback onPress={goToLogin}>
              <Image style={webStyles.logo} source={LogoLight} />
            </TouchableWithoutFeedback>
          </View>
          <View style={webStyles.mainContainer}>
            <View style={webStyles.titleContainer}>
              <RNEText
                label="Privacy Policy"
                variant="header"
                weight="bold"
                color="accent"
              />
              <View style={webStyles.privacyContainer}>
                <TouchableOpacity activeOpacity={0.75} onPress={onTermsClick}>
                  <RNEText
                    label="Terms and Conditions "
                    variant="button"
                    weight="bold"
                  />
                </TouchableOpacity>
                <RNEText label="here" variant="button" />
              </View>
            </View>
            <ContentScrollView isWeb={Platform.OS === 'web'}>
              <HTML
                source={{
                  html: HTMLPrivacyPolicy,
                }}
              />
            </ContentScrollView>
          </View>
        </View>
      ) : (
        <ScrollView
          onScroll={handleScroll}
          onLayout={e => {
            setScrollViewHeight(e.nativeEvent.layout.height);
          }}
          onContentSizeChange={(contentWidth, contentHeight) => {
            setContentHeight(contentHeight);
          }}>
          <View style={mobileStyles.mainContainer}>
            <RNEText
              label="Privacy Policy"
              variant="header"
              weight="bold"
              color="accent"
              style={{fontSize: totalSize(2.8), marginLeft: -width(1.5)}}
            />

            <HTML
              baseStyle={{fontSize: totalSize(1.8)}}
              defaultTextProps={{
                allowFontScaling: false,
              }}
              source={{
                html: HTMLPrivacyPolicy,
              }}
            />
          </View>
        </ScrollView>
      )}
    </>
  );
};

export default PrivacyPolicyAuthScreen;

const webStyles = StyleSheet.create({
  root: {flex: 1, height: '100%', width: '100%', padding: 48},
  logoContainer: {
    width: '100%',
    maxWidth: '1024px',
    alignSelf: 'center',
  },
  logo: {
    width: 200,
    height: 44,
  },
  mainContainer: {
    width: '100%',
    maxWidth: 760,
    alignSelf: 'center',
    flex: 1,
    marginTop: '10vh',
    maxHeight: '60vh',
  },
  titleContainer: {
    marginBottom: 40,
  },
  privacyContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mainWrapper: {
    flex: 1,
    paddingRight: 48,
  },
});

const mobileStyles = StyleSheet.create({
  mainContainer: {
    // paddingVertical: 20,
    // paddingHorizontal: 24,
    paddingVertical: totalSize(0.2),
    paddingHorizontal: totalSize(2.5),
  },
});
